var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNricInfo = function SvgNricInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.1.9-Telecounsel-/-Queue----in-call---cam-off",
    transform: "translate(-848, -800)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(480, 784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Copy-2",
    transform: "translate(352, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16, 16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "currentColor",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2727273,0 L2.72727273,0 C1.22172308,0.00160746589 0.00164399921,1.19457368 0,2.66666667 L0,17.3333333 C0.00164399921,18.8054263 1.22172308,19.9983925 2.72727273,20 L12.2727273,20 C13.7782769,19.9983925 14.998356,18.8054263 15,17.3333333 L15,2.66666667 C14.998356,1.19457368 13.7782769,0.00160746589 12.2727273,0 L12.2727273,0 Z M10.8017045,11.1879167 C11.1242898,11.5283333 11.2819602,11.98625 11.2444602,12.4770833 C11.1707386,13.4545833 10.4083807,14.25 9.54545455,14.25 C8.68252841,14.25 7.91889205,13.4545833 7.84602273,12.4770833 C7.809375,11.98125 7.96576705,11.5225 8.28664773,11.1854167 C8.60752841,10.8483333 9.05113636,10.6666667 9.54545455,10.6666667 C10.0205327,10.6599836 10.4765342,10.8491902 10.8017045,11.1879167 L10.8017045,11.1879167 Z M4.77272727,2.66666667 C4.77272727,2.29847683 5.07798767,2 5.45454545,2 L9.54545455,2 C9.92201233,2 10.2272727,2.29847683 10.2272727,2.66666667 C10.2272727,3.0348565 9.92201233,3.33333333 9.54545455,3.33333333 L5.45454545,3.33333333 C5.07798767,3.33333333 4.77272727,3.0348565 4.77272727,2.66666667 Z M12.8267045,17.82625 C12.7272917,17.9387431 12.5820027,18.0023727 12.4299716,18 L6.6609375,18 C6.50890638,18.0023727 6.36361737,17.9387431 6.26420455,17.82625 C6.15635043,17.6999255 6.11307528,17.5325113 6.14659091,17.37125 C6.28508523,16.6395833 6.71676136,16.025 7.39517045,15.59375 C7.99772727,15.2108333 8.76136364,15 9.54545455,15 C10.3295455,15 11.0931818,15.2108333 11.6957386,15.59375 C12.3741477,16.025 12.8058239,16.6395833 12.9443182,17.37125 C12.9778338,17.5325113 12.9345587,17.6999255 12.8267045,17.82625 L12.8267045,17.82625 Z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNricInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nric-info.da155577.svg";
export { ForwardRef as ReactComponent };